/****************************************************************************************
 * File Name    : FinishedViewer.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div class="">
        <div @click="handlerForCloseDrawer()" class="report-viewer-close-btn" style="position:absolute; top:4px; right:18px; cursor:pointer; font-size:34px; font-weight:bold; -webkit-text-stroke:1px #fff; background-color:#eee;     border:1px solid #ccc;     padding:0 10px; line-height: 1.2; border-radius:4px; z-index:10;">X</div>
        <div v-if = "flagSpinner === false">
            <div v-if="showSaveBtn" style="position:relative;">
                <!-- 헤더 영역 - SafetyReportViewer.vue와 동일한 구조로 변경 -->
                <div class="report-header">
                    <div class="report-title">{{ target.title }}</div>
                    <div class="report-info-container">
                        <div class="report-info-group">
                            <div class="report-info-label">작성일자</div>
                            <div class="report-info-value">{{ target.updated }}</div>
                        </div>
                        <div class="report-info-group">
                            <div class="report-info-label">소속(라인)</div>
                            <div class="report-info-value">
                                <input 
                                    type="text" 
                                    v-model="target.line"
                                    placeholder="" 
                                    style="margin:0; padding:2px; width:160px; border:1px solid #ddd;"
                                    @change="changeValue"
                                />
                            </div>
                        </div>
                        <div class="report-info-group">
                            <div class="report-info-label">점검자</div>
                            <div class="report-info-value">
                                <a-input v-model="target.manager" @change="changeValue" style="width: 80px; margin-right:5px;"/>
                                <div style="display: inline-block; cursor:pointer; margin-left: 10px; border: 1px dashed #ccc; padding: 0 5px;">
                                    <span v-if="!signatureImage">(서명)</span>
                                    <img v-if="signatureImage" :src="signatureImage" style="max-height: 30px; max-width: 60px;" @click.stop="viewSignature" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--  -->
                <a-divider type = 'horizontal' />
                <div class = 'todo'>점검정보 출력방식 변경, 정렬</div>
                <!-- {{target.listProductCSInpection}} -->
                <div class="image-container">
                    <a-row :gutter="16">
                        <a-col class="gutter-row" :span="12">
                            <div id="image1" class="gutter-box">
                                <img v-if="image1Src" :src="image1Src">
                            </div>
                        </a-col>
                        <a-col class="gutter-row" :span="12">
                            <div id="image2" class="gutter-box">
                                <img v-if="image2Src" :src="image2Src">
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div class="table-container" style="overflow-x: auto;">
                    <table id="sheet-table" class="sheet-table filter-report-table" style="width:100%; border-collapse: collapse; table-layout:fixed; margin-top: 10px; min-width: 800px;">
                        <colgroup>
                            <col style="width:150px">
                            <col style="width:250px">
                            <col style="width:90px">
                            <col style="width:430px">
                            <col style="width:120px">
                        </colgroup>
                        <thead>
                            <tr>
                                <th colspan="2" style="border: 1px solid #e8e8e8; padding:6px; text-align:center; background-color:#586994; color:white;">점검항목<br/>(○ 양호, △ 미흡, X 불량, N/A 해당없음)</th>
                                <th style="border: 1px solid #e8e8e8; padding:6px; text-align:center; background-color:#586994; color:white; min-width:80px;">점검<br/>결과</th>
                                <th style="border: 1px solid #e8e8e8; padding:6px; text-align:center; background-color:#586994; color:white;">조치사항<br/>(점검결과 미흡 또는 불량 시 기재)</th>
                                <th style="border: 1px solid #e8e8e8; padding:6px; text-align:center; background-color:#586994; color:white;">점검<br/>이미지</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,offset) in target.listProductCSInpection" :key="offset">
                                <td v-if="!offset || target.listProductCSInpection[offset-1].inspectionTarget !== item.inspectionTarget" 
                                    :rowspan="getRowspan(item.inspectionTarget)"
                                    style="border: 1px solid #e8e8e8; padding:6px; text-align:center; vertical-align:middle; width:150px; max-width:150px;">
                                    {{item.inspectionTarget}}
                                </td>
                                <td style="border: 1px solid #e8e8e8; padding:6px; text-align:left; width:250px; max-width:250px;">
                                    <span style="display:inline-block; width:20px; text-align:center; vertical-align:top;">○</span>
                                    <span style="display:inline-block; width:calc(100% - 25px);">{{item.inspectionName}}</span>
                                </td>
                                <td style="border: 1px solid #e8e8e8; padding:6px; text-align:center; width:90px; max-width:90px;">
                                    <select v-if="showSaveBtn && !item.listProductCSInpectionStandard[7].min" 
                                        v-model="item.listProductCSInpectionStandard[0].min" 
                                        style="padding:4px; width: 70px;" 
                                        @change="changeValue">
                                        <option value="">  </option>
                                        <option value="○"> ○ </option>
                                        <option value="△"> △ </option>
                                        <option value="X"> X </option>
                                        <option value="N/A"> N/A </option>
                                    </select>
                                    <input v-if="showSaveBtn && item.listProductCSInpectionStandard[7].min" 
                                        type="number" v-model="item.listProductCSInpectionStandard[0].max" 
                                        placeholder="" 
                                        style="padding:4px; width: 70px;"
                                        @change="changeValue" />
                                    <span v-if="!showSaveBtn">{{item.listProductCSInpectionStandard[0].min || item.listProductCSInpectionStandard[0].max}}</span>
                                </td>
                                <td style="border: 1px solid #e8e8e8; padding:6px; width:430px; max-width:430px;">
                                    <input v-if="showSaveBtn" 
                                        type="text" 
                                        v-model="item.listProductCSInpectionStandard[0].result" 
                                        placeholder="" 
                                        style="width: 100%; padding:4px;"
                                        @change="changeValue" />
                                    <span v-if="!showSaveBtn">{{item.listProductCSInpectionStandard[0].result}}</span>
                                </td>
                                <td style="border: 1px solid #e8e8e8; padding:6px; text-align:center; width:120px; max-width:120px;">
                                    <div style="display:flex; flex-direction:row; align-items:center; justify-content:flex-start; gap:5px;">
                                        <div v-html="inspectionImageList2(offset)" style="display:flex; flex-direction:row; justify-content:flex-start; align-items:center; flex-wrap:nowrap; flex:1;"></div>
                                        <a-upload v-if="showSaveBtn" 
                                            name="file" 
                                            :multiple="false" 
                                            :action="$store.state.imageUploadServer" 
                                            v-on:change="imageUpload2(item)" 
                                            @change="imageUpload">
                                            <a-button style="margin-left:auto;"> <a-icon type="camera" /> </a-button>
                                        </a-upload>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style="border: 1px solid #e8e8e8; padding:6px;">기타 특이사항</td>
                                <td colspan="4" style="border: 1px solid #e8e8e8; padding:6px;">
                                    <a-textarea v-if="showSaveBtn" :rows="3" v-model="target.special_note" />
                                    <div v-else style="white-space: pre-wrap; line-height: 1.5;">{{target.special_note}}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                <table id="sheet-table" class="sheet-table" style='width:100%; border: 1px solid #e8e8e8; display: none;'>
                    <thead class="ant-table-thead">
                        <tr>
                            <th style="width:15%;">공정명</th>
                            <th style="width:20%;">점검 항목</th>
                            <th>참고 이미지</th>
                            <th style="padding-left:0; padding-right:0;">
                                <ul style="margin:0 0 0 7px; padding:0; list-style:none; overflow:hidden;">
                                    <li style="float:left; margin-right:60px; width:120px; text-align:center;">09:00:~10:50</li>
                                    <li style="float:left; margin-right:60px; width:120px; text-align:center;">11:00:~12:30</li>
                                    <li style="float:left; margin-right:60px; width:120px; text-align:center;">13:30:~15:30</li>
                                    <li style="float:left; margin-right:60px; width:120px; text-align:center;">15:45:~18:00</li>
                                    <li style="float:left; margin-right:60px; width:120px; text-align:center;">18:30:~20:30</li>
                                </ul>
                            </th>
                            <th style="max-width:120px;"></th>
                            <th>사진</th>
                        </tr>
                    </thead>
                    <tbody class="ant-table-tbody">
                        <tr v-bind:class="{even: item.isEven}" v-for = "(item,offset) in target.listProductCSInpection" :key = "offset">
                            <td>{{item.inspectionTarget}}</td>
                            <td style="position:relative;">{{item.inspectionName}}</td>
                            <td>
                                <a-button v-if="item.inspectionImageSeq && item.inspectionImageSeq != '0'" @click="viewInspectionImage(offset)"> <a-icon type="picture" /> </a-button>
                            </td>
                            <td style="padding:0;">
                                <div style="overflow:hidden;">
                                    <div v-for = "(item2,offset2) in item.listProductCSInpectionStandard" :key="offset2" style="float:left; padding:5px;">
                                        <div v-if="offset2 % 3 === 0">
                                            <div v-if="showSaveBtn" style="display:inline-block;">
                                                <select v-model="item2.min" style="padding:4px; width: 120px" >
                                                    <option value="">  </option>
                                                    <option value="○"> ○ </option>
                                                    <option value="△"> △ </option>
                                                    <option value="X"> X </option>
                                                    <option value="N/A"> N/A </option>
                                                </select>
                                                <br>
                                                <input type="text" v-model="item2.result" placeholder="" style="width: 120px"/>
                                                <br>
                                                <select v-model="item2.max"   style="padding:4px; width: 120px" >
                                                    <option value=""></option><option value="mm">mm</option>
                                                    <option value="cm">cm</option>
                                                    <option value="mA">mA</option>
                                                    <option value="A">A</option>
                                                    <option value="mV">mV</option>
                                                    <option value="V">V</option>
                                                    <option value="W">W</option>
                                                    <option value="kW">kW</option>
                                                    <option value="Ω">Ω</option>
                                                    <option value="kΩ">kΩ</option>
                                                    <option value="MΩ">MΩ</option>
                                                    <option value="ml">ml</option>
                                                    <option value="l">l</option>
                                                    <option value="mg">mg</option>
                                                    <option value="g">g</option>
                                                    <option value="℃">℃</option>
                                                    <option value="ppm">ppm</option>
                                                </select>
                                            </div>
                                            <div style="display:inline-block; width:30px; position: relative; top:-25px;">
                                                <div style="display:table-cell; vertical-align:middle;">
                                                    <a-icon v-if="item2.min === 'NG'" @click="viewNgNote(offset, offset2)" type="question-circle" style="margin-left:20px; font-size:20px; cursor:pointer;" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div v-html="inspectionImageList2(offset, item.produtCsInspectionSeq)"></div>
                            </td>
                            <td>
                                <a-upload name="file" :multiple="false" :action="$store.state.imageUploadServer" v-on:change="imageUpload2(item)"  @change="imageUpload"
                                    v-decorator="['imageSeq2',{rules: [{ required: true, message: '이미지를 선택하세요' }],},]">
                                    <a-button> <a-icon type="camera" /> </a-button>
                                </a-upload>
                            </td>
                        </tr>
                        <!-- <a-tag v-if="item.inspectionDescription" color="">설명</a-tag> -->
                        <!-- <a-divider type = 'vertical' /> -->
                        <!-- {{item.inspectionDescription}}
                        <a-divider type = 'horizontal' /> -->
                    </tbody>
                </table>
                
                <div style="margin-top:20px; text-align:center;">
                    <a-button type="default" icon="plus-circle" size = "default" @click="handlerForCloseDrawer(target, 'U')" >
                        임시저장
                    </a-button>
                    <a-button type="primary" icon="plus-circle" size = "default" @click="openSignatureForCompletion" style="margin-left:20px;">
                        완료
                    </a-button>
                </div>
                
                <!-- 안전보건 준수사항 박스 -->
                <div style="margin-top: 30px;" v-if="!loading" v-html="safetyHTML"></div>
                <div style="margin-top: 30px; text-align: center;" v-else>
                    <a-spin tip="안전보건 정보를 불러오는 중..."></a-spin>
                </div>
            </div>
            <a-card v-if="!showSaveBtn" :title = "target.name">
                <!--  -->
                <div class = 'todo'>상품정보 출력방식 변경</div>
                <a-list item-layout="horizontal" :data-source="data">
                    <a-list-item slot="renderItem" slot-scope="item">
                        <a-list-item-meta :description="productDescription">
                            <span slot="title">{{ item.title }}</span>
                            <a-avatar slot="avatar" :src="productImagePath" ref=""/>
                        </a-list-item-meta>
                    </a-list-item>
                </a-list>
                <!--  -->
                <a-divider type = 'horizontal' />
                <div class = 'todo'>점검정보 출력방식 변경, 정렬</div>
                <!-- {{target.listProductCSInpection}} -->
                <div v-for = "(item,offset) in target.listProductCSInpection" :key = "offset">
                    <a-tag color="#108ee9">분류 {{item.inspectionIndex}} </a-tag>
                    <!-- <a-divider type = 'vertical' /> -->
                    {{item.inspectionTarget}}
                    <p/>
                    <a-tag color="#108ee9">항목 {{item.inspectionIndex}}-{{item.inspectionOffset}} </a-tag>
                    <!-- <a-divider type = 'vertical' /> -->
                    {{item.inspectionName}}
                    <p/>
                    <!-- <a-tag color="">규격</a-tag> -->
                    <!-- <a-divider type = 'vertical' /> -->
                    <div v-for = "(item2,offset2) in item.listProductCSInpectionStandard" :key = "offset2" style="white-space: pre-line;">
                        {{item2.name}}
                        <p/>
                        <!-- <a-tag color="">측정기기</a-tag> -->
                        <div>{{item2.result}}</div>
                        <!-- <div v-if="!pop">
                            {{item2.min}} ~ {{item2.max}}
                            <br>
                            {{item2.result}}
                        </div>
                        <div v-if="pop"> -->
                        <div v-if="showSaveBtn">
                            <select v-model="item2.min"   style="padding:4px; width: 70px" >
                                <option value="○"> ○ </option>
                                <option value="△"> △ </option>
                                <option value="X"> X </option>
                                <option value="N/A"> N/A </option>
                            </select>
                            <a-input v-model="item2.result" placeholder="" style="margin-left: 20px; width: 100px"/>
                            <select v-model="item2.max"   style="margin-left:5px; padding:4px; width: 50px" >
                                <option value=""></option><option value="mm">mm</option>
                                <option value="cm">cm</option>
                                <option value="mA">mA</option>
                                <option value="A">A</option>
                                <option value="mV">mV</option>
                                <option value="V">V</option>
                                <option value="W">W</option>
                                <option value="kW">kW</option>
                                <option value="Ω">Ω</option>
                                <option value="kΩ">kΩ</option>
                                <option value="MΩ">MΩ</option>
                                <option value="ml">ml</option>
                                <option value="l">l</option>
                                <option value="mg">mg</option>
                                <option value="g">g</option>
                                <option value="℃">℃</option>
                                <option value="ppm">ppm</option>
                            </select>
                            <!-- <a-input v-model="item2.min" placeholder="" style="width: 50px"/>
                            -
                            <a-input v-model="item2.max" placeholder="" style="width: 50px"/>
                            <br>
                            <a-input v-model="item2.result" placeholder="" style="width: 300px"/> -->
                        </div>
                    </div>
                    <p/>
                    <a-tag v-if="item.inspectionDescription" color="">설명</a-tag>
                    <!-- <a-divider type = 'vertical' /> -->
                    {{item.inspectionDescription}}
                    <a-divider type = 'horizontal' />
                </div>
            </a-card>
        </div>
        <a-skeleton v-else />
        <div id="image-viewer-container" style="display:none; position:absolute; top:0; left:0; width:100%; height:100%; background-color:rgba(0,0,0,0.3);">
            <div id="image-viewer" style="position:absolute; top:5%; left:5%; width:90%; height:90%; background-color:#fff; border:1px solid #ccc;">
                <div id="image-viewer-close" @click="imageViewerClose()" style="position:absolute; top:23px; right:20px; cursor:pointer; font-size:34px; font-weight:bold; -webkit-text-stroke:1px #fff; background-color:#eee;     border:1px solid #ccc;     padding:0 10px; line-height: 1.2; border-radius:4px;">X</div>
                <div id="image-viewer-content" style="height:100%; overflow:auto;"></div>
            </div>
        </div>
        <div id="ng-note-container" style="display:none; position:absolute; top:0; left:0; width:100%; height:100%; background-color:rgba(0,0,0,0.3);">	
            <div id="ng-note" style="position:absolute; top:20%; left:20%; width:60%; height:60%; background-color:#fff; border:1px solid #ccc;">	
                <div id="ng-note-close" @click="ngNoteClose()" style="position:absolute; top:10px; right:20px; cursor:pointer; font-size:30px; font-weight:bold; z-index:10;">X</div>	
                <a-card title = "NG 기록하기">	
                    <a-input v-model="ngTitle" placeholder="제목" />	
                    <a-textarea v-model="ngContent" placeholder="NG 내용 기록" rows="17" style="margin-top:20px;"></a-textarea>	
                    <div style="margin-top:20px; text-align:center;">	
                        <a-button @click="ngNoteClose()" type="default" icon="plus-circle" size = "default" >	
                            취소	
                        </a-button>	
                        <a-button @click="saveNgNote()" type="primary" icon="plus-circle" size = "default" style="margin-left:20px;">	
                            완료	
                        </a-button>	
                    </div>	
                </a-card>	
            </div>	
        </div>
        <div id="signature-viewer-container" style="display:none; position:absolute; top:0; left:0; width:100%; height:100%; background-color:rgba(0,0,0,0.3); z-index:1000;">
            <div style="position:absolute; top:50%; left:50%; transform:translate(-50%, -50%); max-width:80%; max-height:80%; background-color:#fff; border:1px solid #ccc; padding:20px; box-shadow:0 4px 12px rgba(0,0,0,0.15);">
                <div style="position:absolute; top:10px; right:10px; cursor:pointer; font-size:18px; font-weight:bold;" @click="closeSignatureViewer">×</div>
                <img :src="signatureImage" style="max-width:100%; max-height:100%;" />
            </div>
        </div>
        <SignatureModal 
            :visible="signatureModalVisible" 
            @cancel="handleSignatureCancel" 
            @save="handleSignatureSave"
            :initial-signature="signatureImage"
        />
    </div>
</template>
<script>
import _ from "lodash";
import $ from "jquery";
import SignatureModal from "../components/SignatureModal.vue";
const data = [{title:'제품명'}];
export default {
    name: 'PatrolViewer',
    props : ['target', 'flagForDrawer', 'pop', 'showSaveBtn', 'showConfirmBtn'],
    components: {
        SignatureModal
    },
    data() {
        return {
            flagSpinner : false,
            data,
            fileUploadSeq   : 0,
            fileUploadItem : null,
            ngTitle: '',	
            ngContent: '',	
            offset: 0,	
            offset2: 0,
            uploadFileSeq: [],
            image1Src: '',
            image2Src: '',
            signatureImage: null,
            signatureModalVisible: false,
            signForCompletion: false,
            safetyHTML: '',
            loading: true,
            
            // 안전보건 준수사항
            safetyContent: {
                title: '',
                leftItems: [],
                rightItems: [],
                unsafeActionDesc: '',
                footerNote: ''
            },
            
            // 점검자 업무
            supervisorContent: {
                title: '',
                items: []
            },
            
            // 작업시작 전 점검사항
            inspectionContent: {
                title: '',
                categories: []
            },
            
            // 하단 문구
            footerPhrase: ''
        };
    },
    mounted() {
        this.setListProductCSInpection();

        this.target.updated = this.target.updated.substr(0, 10);

        if (!this.target.manager) {
            this.target.manager = sessionStorage.getItem('user_name');
        }
        
        // 라인 옵션 초기화
        if (!this.target.line || this.target.line.trim() === '') {
            this.target.line = '';
            this.target.lineOption = '';
        } else {
            // target.line이 있는 경우
            if (['CI01', 'CI02', 'CI03', 'CI04', 'CI05', 'CI06', 'CI07', 'CI08', 'CI09', 'CI10', 
                   'CI11', 'CI12', 'CI13', 'CI14', 'CI15', 'CI16', 'CI17', 'CI18', 'CI19', 'CI20',
                   'CF01', 'CF02', 'CF03', 'CF04', 'CF05', 'CF06', 'CF07', 'CF08', 'CF09', 'CF10', 
                   'CF11', 'CF12', 'CF13', 'CF14', 'CF15', 'CF16', 'CF17', 'CF18', 'CF19', 'CF20'].includes(this.target.line)) {
                // 표준 옵션 중 하나라면 lineOption을 line과 동일하게 설정
                this.target.lineOption = this.target.line;
            } else {
                // 표준 옵션이 아니라면 기타로 설정
                this.target.lineOption = 'etc';
            }
        }

        if (this.target.image1) {
            this.image1Src = this.$store.state.hostInService +'/upload/image/download/' + this.target.image1;
            console.log(this.image1Src)
        } else {
            this.image1Src = '';
        }

        if (this.target.image2) {
            this.image2Src = this.$store.state.hostInService +'/upload/image/download/' + this.target.image2;
        } else {
            this.image2Src = '';
        }
        
        // 서명 데이터 조회
        this.fetchSignatureData();

        // DB에서 안전보건 데이터 가져오기
        this.fetchSafetyContent();
    },
    watch: {
        target: function(newOne){
            this.target = newOne;
            this.target.updated = this.target.updated.substr(0, 10);

            if (!this.target.manager) {
                this.target.manager = sessionStorage.getItem('user_name');
            }

            if (this.target.image1) {
                this.image1Src = this.$store.state.hostInService +'/upload/image/download/' + this.target.image1;
                console.log(this.image1Src)
            } else {
                this.image1Src = '';
            }

            if (this.target.image2) {
                this.image2Src = this.$store.state.hostInService +'/upload/image/download/' + this.target.image2;
            } else {
                this.image2Src = '';
            }

            this.setListProductCSInpection();
            
            // 서명 데이터 조회
            this.fetchSignatureData();
        }
    },
    computed : {
        productDescription() {
            let buffer = this.target.clsProduct.productName + " (" + this.target.clsProduct.productModel + ") ";
            for(let x = 0; x < this.target.clsProduct.listProductFunction.length; x ++ ) {
                buffer = buffer + this.target.clsProduct.listProductFunction[x].productFunctionName + ",";
            }
            return buffer;
        },
        productImagePath() {
            return this.$store.state.hostInService + '/upload/image/download/' + this.target.clsProduct.uploadFileSeq;
        },

    },
    methods : {
        setListProductCSInpection() {
            this.target.listProductCSInpection = _.sortBy(this.target.listProductCSInpection, ['inspectionIndex', 'inspectionOffset']);

            let isEven = false;
            let oldInspectionIndex = '';
            _.forEach(this.target.listProductCSInpection, (item) => {
                if (!oldInspectionIndex) {
                    oldInspectionIndex = item.inspectionIndex;
                }

                if (item.inspectionIndex !== oldInspectionIndex) {
                    oldInspectionIndex = item.oldInspectionIndex;

                    isEven = !isEven;
                }

                item.isEven = isEven;
            });
        },
        inspectionImageList(offset) {
            let html = '';
            let imageSeq = [];
            if (this.target.listProductCSInpection[offset].inspectionImageSeq && this.target.listProductCSInpection[offset].inspectionImageSeq != '0') {
                imageSeq = this.target.listProductCSInpection[offset].inspectionImageSeq.split('||');
            }

            _.forEach(imageSeq, (item) => {
                let src = this.$store.state.hostInService +'/upload/image/download/' + item;
                html += '<p style="margin:20px; text-align:center;"><img src = "' + src + '" style = "max-width:100%;"/></p>';
            });

            return html;
        },
        inspectionImageList2(offset) {
            let self = this;

            let html = '';
            let imageSeq = [];
            if (self.target.listProductCSInpection[offset].inspectionImage2Seq && self.target.listProductCSInpection[offset].inspectionImage2Seq != '0') {
                imageSeq = self.target.listProductCSInpection[offset].inspectionImage2Seq.split('||');
            }

            // 테이블 레이아웃으로 가로 정렬
            html += '<div style="display:flex; flex-direction:row; flex-wrap:nowrap; justify-content:center; gap:10px;">';
            
            imageSeq = imageSeq.filter(item => item !== '0' && item !== '');
            
            _.forEach(imageSeq, (item) => {
                let src = self.$store.state.hostInService +'/upload/image/download/' + item;
                html += '<div style="display:inline-block; text-align:center;">';
                html += '<a href="' + src + '" target="_blank" id="view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item + '">';
                html += '<img src="' + src + '" style="width:18px; height:18px; object-fit:cover; margin:0 2px;"/>';
                html += '</a>';
                if (self.showSaveBtn) {
                    html += '<span id="delete-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item + '" style="display:block; font-size:10px; cursor:pointer;">삭제</span>';
                }
                html += '</div>';

                ((self) => {
                    // 이미지 보기
                    $('body').off('click.view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item).on('click.view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item, '#view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item , function(e) {
                        e.preventDefault();

                        let html = '<p style="margin:20px; text-align:center;"><img src = "' + src + '" style = "max-width:100%;"/></p>';

                        self.viewInspectionImage2(html);
                    });

                    // 이미지 삭제
                    $('body').off('click.delete-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item).on('click.delete-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item, '#delete-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item , function() {
                        if (confirm('삭제하시겠습니까?')) {
                            imageSeq.splice(imageSeq.indexOf('' + item), 1);
                            
                            self.target.listProductCSInpection[offset].inspectionImage2Seq = imageSeq.join('||');
                            self.changeValue();
                            
                            // 새로 렌더링
                            let container = document.querySelector('#view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item).closest('div[v-html]');
                            if (container) {
                                container.innerHTML = self.inspectionImageList2(offset);
                            }
                        }
                    });
                })(self);
            });
            
            html += '</div>';
            
            return html;
        },
        productInspectionPath(offset) {
            return this.$store.state.hostInService +'/upload/image/download/' + this.target.listProductCSInpection[offset].inspectionImageSeq;
        },
        productInspectionPath2(offset) {
            return this.$store.state.hostInService +'/upload/image/download/' + this.target.listProductCSInpection[offset].inspectionImage2Seq;
        },
        handlerForCloseDrawer(target, state) {
            this.$emit('flagForDrawer');

            if (target) {
                this.$emit('editSafetyCS', target, state);
            }
        },
        imageUpload(info) {
            this.spinning = info.file.status === 'uploading' ? true : false;
            if(info.file.status === 'done') {
                this.$message.success(`${info.file.name} file uploaded successfully`);
                let temp = this.fileUploadItem.inspectionImage2Seq.split('||');
                temp.push(info.file.response.data.uploadFileSeq);
                this.fileUploadItem.inspectionImage2Seq = temp.join('||');
                            
                this.changeValue();
                
                // 이미지 리사이징 API 호출
                this.$http.post(`${this.$store.state.nodeApiUrl}/user/resize-image`, {
                    uploadFileSeq: info.file.response.data.uploadFileSeq
                })
                .then(response => {
                    if (response.data.code === 'success') {
                        console.log('✅ Image resized:', response.data.data);
                    }
                })
                .catch(error => {
                    console.error('❌ Resize failed:', error);
                });
            } else if(info.file.status === 'error') {
                this.$message.error(`${info.file.name} file upload failed.`);
            }
        },
        imageUpload2(item) {
            this.fileUploadItem = item;
        },
        viewInspectionImage(offset) {
            let self = this;
            let html = '';
            let src = this.$store.state.hostInService +'/upload/image/download/' + self.target.listProductCSInpection[offset].inspectionImageSeq;
            html = '<p style="margin:20px; text-align:center;"><img src = "' + src + '" style = "max-width:100%;"/></p>';
            this.viewInspectionImage2(html);
        },
        viewInspectionImage2(html) {
            document.getElementById('image-viewer-container').style.display = 'block';
            document.getElementById('image-viewer-content').innerHTML = html;
        },
        imageViewerClose() {
            document.getElementById('image-viewer-container').style.display = 'none';
            document.getElementById('image-viewer-content').innerHTML = '';
        },
        viewNgNote(offset, offset2) {	
            this.offset = offset;	
            this.offset2 = offset2;	
            var item = this.target.listProductCSInpection[offset].listProductCSInpectionStandard[offset2];	
            this.ngTitle = item.ngTitle;	
            this.ngContent = item.ngContent;	
            document.getElementById('ng-note-container').style.display = 'block';	
        },	
        saveNgNote() {	
            var item = this.target.listProductCSInpection[this.offset].listProductCSInpectionStandard[this.offset2];	
            item.ngTitle = this.ngTitle;	
            item.ngContent = this.ngContent;	
            this.ngNoteClose();	
            this.changeValue();
        },	
        ngNoteClose() {	
            this.ngTitle = '';	
            this.ngContent = '';	
            document.getElementById('ng-note-container').style.display = 'none';	
        },
        getAverage(item) {
            let count = 0;
            if (item[0].max) {
                count++;
            }
            if (item[1].max) {
                count++;
            }
            if (item[2].max) {
                count++;
            }
            if (item[3].max) {
                count++;
            }
            if (item[4].max) {
                count++;
            }

            if (count === 0) {
                return;
            }

            let temp = (+(item[0].max) + +(item[1].max) + +(item[2].max) + +(item[3].max) + +(item[4].max)) / count;
            temp = +(temp.toFixed(2));

            item[5].max = temp;
        },
        changeValue() {
            localStorage.setItem('cs_item_seq_' + this.target.productCsSeq, JSON.stringify(this.target));
        },
        getRowspan(inspectionTarget) {
            return this.target.listProductCSInpection.filter(item => item.inspectionTarget === inspectionTarget).length;
        },
        validateBeforeComplete() {
            // 모든 점검 항목을 순회
            for (const item of this.target.listProductCSInpection) {
                const min = item.listProductCSInpectionStandard[0].min;
                const result = item.listProductCSInpectionStandard[0].result;
                if ((min === '△' || min === 'X') && (!result || result.trim() === '')) {
                    this.$message.error('미흡(△) 또는 불량(X) 선택 시 조치사항을 입력해야 합니다.');
                    return false;
                }
            }
            return true;
        },
        openSignatureForCompletion() {
            // 완료 버튼 클릭 시 검증
            if (!this.validateBeforeComplete()) {
                return;
            }
            this.signForCompletion = true;
            this.openSignaturePopup();
        },
        openSignaturePopup() {
            this.signatureModalVisible = true;
        },
        handleSignatureCancel() {
            this.signatureModalVisible = false;
            this.signForCompletion = false;
        },
        handleSignatureSave(signatureData) {
            this.signatureImage = signatureData;
            this.signatureModalVisible = false;
            
            // 서명 이미지를 서버에 저장하는 API 호출
            this.saveSignatureToServer(signatureData);
            
            // 완료 버튼에서 호출한 경우 완료 처리 진행
            if (this.signForCompletion) {
                this.handlerForCloseDrawer(this.target, 'V');
                this.signForCompletion = false;
            }
        },
        saveSignatureToServer(signatureData) {
            // 서버에 이미지 데이터를 저장하는 API 호출 예시
            if (!this.target) return;
            
            const apiUrl = this.$store.state.nodeApiUrl + '/product/cs/save_signature_data';
            const payload = {
                signatureData: signatureData,
                productCsSeq: this.target.productCsSeq
            };
            
            this.$http.post(apiUrl, payload)
                .then(response => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.$message.success('서명이 저장되었습니다.');
                    } else {
                        this.$message.error('서명 저장에 실패했습니다.');
                    }
                })
                .catch(error => {
                    console.error('서명 저장 오류:', error);
                    this.$message.error('서명 저장 중 오류가 발생했습니다.');
                });
        },
        fetchSignatureData() {
            if (!this.target || !this.target.productCsSeq) return;
            
            const apiUrl = this.$store.state.nodeApiUrl + '/product/cs/get_signature_data?productCsSeq=' + this.target.productCsSeq;
            
            this.$http.get(apiUrl)
                .then(response => {
                    if (response.status === 200 && response.data.code === 'success' && response.data.data) {
                        this.signatureImage = response.data.data;
                    } else {
                        this.signatureImage = null;
                    }
                })
                .catch(error => {
                    console.error('서명 데이터 조회 오류:', error);
                });
        },
        viewSignature() {
            document.getElementById('signature-viewer-container').style.display = 'block';
        },
        closeSignatureViewer() {
            document.getElementById('signature-viewer-container').style.display = 'none';
        },
        fetchSafetyContent() {
            this.loading = true;
            
            // API를 통해 데이터 불러오기
            this.$http.get(this.$store.state.nodeApiUrl + '/product/get_system_data')
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        let systemData = response.data.data.content[0];
                        
                        // DB에 저장된 데이터가 있으면 파싱해서 적용
                        if (systemData && systemData.safety_compliance) {
                            try {
                                const data = JSON.parse(systemData.safety_compliance);
                                this.safetyContent = data.safetyContent || this.safetyContent;
                                this.supervisorContent = data.supervisorContent || this.supervisorContent;
                                this.inspectionContent = data.inspectionContent || this.inspectionContent;
                                this.footerPhrase = data.footerPhrase || this.footerPhrase;
                                
                                // HTML 생성
                                this.generateSafetyHTML();
                            } catch (e) {
                                console.error('안전보건 콘텐츠 파싱 오류:', e);
                                this.useFallbackHTML();
                            }
                        } else {
                            this.useFallbackHTML();
                        }
                    } else {
                        console.error('시스템 데이터 조회 실패:', response);
                        this.useFallbackHTML();
                    }
                    
                    this.loading = false;
                })
                .catch(error => {
                    console.error('시스템 데이터 조회 오류:', error);
                    this.useFallbackHTML();
                    this.loading = false;
                });
        },
        
        // 동적 HTML 생성
        generateSafetyHTML() {
            let html = `
<div style="margin-top: 30px;">
    <!-- 안전보건 준수사항 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; background-color:#fffdf0; border: 1px solid #e5e5c9;">
        <tr>
            <td colspan="2" style="padding: 5px; text-align: center; font-weight: bold; font-size: 14px; border-bottom: 1px solid #e5e5c9;">${this.safetyContent.title}</td>
        </tr>
        <tr>
            <td style="width:50%; padding:5px 10px; vertical-align:top; font-size:12px; line-height:1.6; border-right: 1px solid #e5e5c9;">
                ${this.safetyContent.leftItems.map(item => `<div>${item}</div>`).join('')}
            </td>
            <td style="width:50%; padding:5px 10px; vertical-align:top; font-size:12px; line-height:1.6;">
                ${this.safetyContent.rightItems.map(item => `<div>${item}</div>`).join('')}
                ${this.safetyContent.unsafeActionDesc ? `<div style="color:#ff0000; font-size:11px; line-height:1.4;">${this.safetyContent.unsafeActionDesc}</div>` : ''}
            </td>
        </tr>
        <tr>
            <td colspan="2" style="padding:5px; text-align:center; font-size:11px; border-top: 1px solid #e5e5c9;">${this.safetyContent.footerNote}</td>
        </tr>
    </table>
    
    <!-- 점검자 업무 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; background-color:#ffffff; border: 1px solid #e5e5c9; border-top: none;">
        <tr>
            <td style="padding:5px; text-align:center; font-size:11px; font-weight:bold;">${this.supervisorContent.title}</td>
        </tr>
        <tr>
            <td style="padding:5px 10px; font-size:11px; line-height:1.5;">
                ${this.supervisorContent.items.map(item => `<div style="margin-bottom:3px;">${item}</div>`).join('')}
            </td>
        </tr>
    </table>
    
    <!-- 점검자 작업시작 전 점검사항 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; margin-top:20px; border: 1px solid #e5e5c9; font-size:11px;">
        <tr>
            <td colspan="2" style="padding:6px; text-align:center; background-color:#f0f0f0; font-weight:bold; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.title}
            </td>
        </tr>`;
            
            // 카테고리를 2개씩 짝지어 행을 구성
            for (let i = 0; i < this.inspectionContent.categories.length; i += 2) {
                html += `
        <tr>
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i]?.title || ''}
            </td>`;
                
                // 홀수 카테고리가 있는 경우
                if (i + 1 < this.inspectionContent.categories.length) {
                    html += `
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i + 1]?.title || ''}
            </td>`;
                } else {
                    // 마지막 홀수 카테고리인 경우 빈 셀 추가
                    html += `
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                
            </td>`;
                }
                
                html += `
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i]?.items.map(item => `<div>${item}</div>`).join('') || ''}
            </td>`;
                
                // 홀수 카테고리의 항목이 있는 경우
                if (i + 1 < this.inspectionContent.categories.length) {
                    html += `
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i + 1]?.items.map(item => `<div>${item}</div>`).join('') || ''}
            </td>`;
                } else {
                    // 마지막 홀수 카테고리인 경우 빈 셀 추가
                    html += `
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                
            </td>`;
                }
                
                html += `
        </tr>`;
            }
            
            html += `
    </table>
    
    <!-- 안전으로 시작해서 품질로 완성하는 문구 -->
    <div style="width:100%; text-align:center; margin-top:10px; font-weight:bold; color:#ff0000; font-size:13px;">
        ${this.footerPhrase}
    </div>
</div>
            `;
            
            this.safetyHTML = html;
        },
        
        // 데이터를 불러오지 못한 경우 기존 하드코딩된 HTML 사용
        useFallbackHTML() {
            this.safetyHTML = `
<div style="margin-top: 30px;">
    <!-- 안전보건 준수사항 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; background-color:#fffdf0; border: 1px solid #e5e5c9;">
        <tr>
            <td colspan="2" style="padding: 5px; text-align: center; font-weight: bold; font-size: 14px; border-bottom: 1px solid #e5e5c9;">안전보건 준수사항</td>
        </tr>
        <tr>
            <td style="width:50%; padding:5px 10px; vertical-align:top; font-size:12px; line-height:1.6; border-right: 1px solid #e5e5c9;">
                <div>1. 작업시작 전 스트레칭 습관화</div>
                <div>2. 개인보호구 착용 철저</div>
                <div>3. 흡연장소 화재예방 준수</div>
                <div>4. 안전장치 임의해체 및 훼손 금지</div>
                <div style="padding-left:13px;">- 인터록장치, 광전차식용보장치, 비상정지장치 등</div>
                <div>5. 전기시설 및 태그 표시 확인</div>
                <div style="padding-left:13px;">- 정비, 청소, 사업교체 등 작업 시</div>
                <div>6. 지내 차량 저정속도 및 도보 시 보행로 이동 준수</div>
                <div style="padding-left:13px;">- 지정속도 : 10km 미만</div>
            </td>
            <td style="width:50%; padding:5px 10px; vertical-align:top; font-size:12px; line-height:1.6;">
                <div>7. 작업 중, 운전 중, 보행 중 유대전화 및 전자기기 사용 금지</div>
                <div>8. 안전작업허가제 준수 (미허가 안전작업 금지)</div>
                <div>9. 불안전한 행동 금지</div>
                <div style="color:#ff0000; font-size:11px; line-height:1.4;">※ 불안전한 행동 : 근무시간 준수, 컨베이어 등 설비 넘어다니거나, 가동중인 설비에 올라가는 행위, 지게차 포크 탑승, 지게차 사이 미확보, 작업과 관련없이 지정 및 설비 등에 올라는 행위(추락위험), 위험설비 작업반경 내 임의 출입 및 신체를 투입, 화학물질을 다른 용도로 사용하는 행위 등 재해를 유발하는 행위 등</div>
            </td>
        </tr>
        <tr>
            <td colspan="2" style="padding:5px; text-align:center; font-size:11px; border-top: 1px solid #e5e5c9;">※ 점검자 업무 및 작업시작 전 점검사항 확인 필수</td>
        </tr>
    </table>
    
    <!-- 점검자 업무 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; background-color:#ffffff; border: 1px solid #e5e5c9; border-top: none;">
        <tr>
            <td style="padding:5px; text-align:center; font-size:11px; font-weight:bold;">점검자의 업무 (산업안전보건법 시행령 제15조)</td>
        </tr>
        <tr>
            <td style="padding:5px 10px; font-size:11px; line-height:1.5;">
                <div style="margin-bottom:3px;">① 산안법 제16조 제1항에 따른 점검자가 지휘·감독하는 업무와 관련된 기계·기구 또는 설비의 안전·보건 점검 및 이상유무 확인</div>
                <div style="margin-bottom:3px;">② 1)소속직원의 안전보건구 및 방호장치의 점검과 그 착용·사용에 관한 교육·지도</div>
                <div style="margin-bottom:3px;">③ 해당 업무(작업)에서 발생한 산업재해에 관한 보고 및 이에 대한 응급조치</div>
                <div style="margin-bottom:3px;">④ 해당 업무(작업)의 작업장 경리정돈 및 통로 확보에 관한 확인 및 감독</div>
                <div style="margin-bottom:3px;">⑤ 산업재해사 안전·보건관리자의 지도·조언에 대한 협조</div>
                <div style="margin-bottom:3px;">⑥ 산업안전보건법 제36조에 따라 위험방지에 관한 담금 작 특히 담무</div>
                <div style="margin-bottom:3px;">가. 투비, 웰딩공사의 화재에 대한 점검</div>
                <div style="margin-bottom:3px;">나. 개선조치 시행에 대한 참여</div>
                <div style="margin-bottom:3px;">⑦ 그 밖에 해당 업무(작업)의 안전·보건에 관한 사항으로서 사업장 및 고용노동부 등에서 결하는 사항</div>
            </td>
        </tr>
    </table>
    
    <!-- 점검자 작업시작 전 점검사항 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; margin-top:20px; border: 1px solid #e5e5c9; font-size:11px;">
        <tr>
            <td colspan="2" style="padding:6px; text-align:center; background-color:#f0f0f0; font-weight:bold; border-bottom: 1px solid #e5e5c9;">
                점검자 작업시작 전 점검사항 (제35조제2항 관련)
            </td>
        </tr>
        <tr>
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                공통가자 반복하여 계속적으로 중량물을 취급하는 작업을 할 때
            </td>
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                전동이어들을 사용하여 작업을 할 때
            </td>
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                <div>가. 중량물 취급의 올바른 자세 및 방식</div>
                <div>나. 허리통이 낮아 둥글임에 따른 보호구의 착용</div>
                <div>다. 카바이드 · 생석회(산화칼슘) 등과 같이 온도상승이나 눌려와도 위험성이 존재하는 중량물의 취급방법</div>
                <div>라. 그 밖에 위적운반기구의 적절한 사용방법</div>
            </td>
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                <div>가. 핸드그리 및 롤러(roller) 기능의 이상 유무</div>
                <div>나. 이앙 둥의 방지장치 기능의 이상 유무</div>
                <div>다. 비상정지장치 기능의 이상 유무</div>
                <div>라. 펌프기 · 회전속 · 기어 및 롤러 등의 덮개 또는 울 등의 이상 유무</div>
            </td>
        </tr>
        <tr>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                혼합 · 용단 작업 등의 화재위험작업을 할 때
            </td>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                이동식 방폭구조(防爆構造) 전기기계 · 기구를 사용할 때
            </td>
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                <div>가. 작업 준비 및 작업 절차 수립 여부</div>
                <div>나. 화기작업에 따른 인근 가연성물질 방호조치 및 소화기구 비치 여부</div>
                <div>다. 옷슬롯의 비산방지덮게 또는 옷롱방화포 등 불꽃 · 불티 등의 비산 방지장치 점검 조치 여부</div>
                <div>라. 인화성 액체의 증기 또는 인화성 가스가 남아 있지 않도록 환기 조치 여부</div>
                <div>마. 작업근로자에 대한 화재예방 및 피난교육 등 비상조치 여부</div>
            </td>
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                <div>가. 전선 및 접속부 상태</div>
                <div>나. 외부 전선의 피복 또는 외장의 손상 유무</div>
                <div>다. 매니플레이터(manipulator) 작동의 이상 유무</div>
                <div>라. 제동장치 및 비상정지장치의 기능</div>
            </td>
        </tr>
        <tr>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                출입 통로 사용하여 작업을 할 때
            </td>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                리프트(자동차정비용 리프트를 포함한다)를 사용하여 작업을 할 때
            </td>
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                <div>가. 통이 불이 있는 출입 · 살아어올림 등이 배달된 상태</div>
                <div>나. 출입 · 살아어올림 등의 상태(작업시작 전 및 작업 중 수시로 확인)</div>
            </td>
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                <div>가. 방호장치 · 브레이크 및 클러치의 기능</div>
                <div>나. 와이어로프가 통하고 있는 곳의 상태</div>
            </td>
        </tr>
        <tr>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                로봇의 작동 범위에서 그 로봇에 관하여 교시 등 작업을 할 때
            </td>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                크레인을 사용하여 작업을 하는 때
            </td>
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                <div>가. 외부 전선의 피복 또는 외장의 손상 유무</div>
                <div>나. 매니플레이터(manipulator) 작동의 이상 유무</div>
                <div>다. 제동장치 및 비상정지장치의 기능</div>
            </td>
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                <div>가. 권과방지장치 · 브레이크 · 클러치 및 운전장치의 기능</div>
                <div>나. 주변통의 상촉 및 트롤리(trolley)가 횡행하는 레일의 상태</div>
                <div>다. 와이어로프가 통하고 있는 곳의 상태</div>
            </td>
        </tr>
        <tr>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                공기압축기를 가동할 때
            </td>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                지게차를 사용하여 작업을 하는 때
            </td>
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9;">
                <div>가. 공기압력 압력용기의 외관 상태</div>
                <div>나. 드레인밸브(drain valve)의 조작 및 배수</div>
                <div>다. 압력방출장치의 기능</div>
                <div>라. 언로딩밸브(unloading valve)의 기능</div>
                <div>마. 공동유의 상태</div>
                <div>바. 회전부의 덮개 또는 울</div>
                <div>사. 그 밖의 연결 부위의 이상 유무</div>
            </td>
            <td style="padding:6px; vertical-align:top;">
                <div>가. 제동장치 및 조향장치 기능의 이상 유무</div>
                <div>나. 하역장치 및 유압장치 기능의 이상 유무</div>
                <div>다. 바퀴의 이상 유무</div>
                <div>라. 전조등 · 후미등 · 방향지시기 및 경보장치 기능의 이상 유무</div>
            </td>
        </tr>
    </table>
    
    <!-- 안전으로 시작해서 품질로 완성하는 문구 -->
    <div style="width:100%; text-align:center; margin-top:10px; font-weight:bold; color:#ff0000; font-size:13px;">
        안전으로 시작해서 품질로 완성하는 우리는 생산/구매분부
    </div>
</div>
            `;
        }
    }
}
</script>
<style scoped>
    .sheet-table th {
        text-align: center;
        font-weight: bold;
    }

    .sheet-table tr th {
        border-left: 1px solid #e8e8e8;
        border-top: 1px solid #e8e8e8;
    }
    
    .sheet-table tr.even {	
        background-color: #e8f7ff;	
    }

    .sheet-table td {
        text-align: center;
        border-left: 1px solid #e8e8e8;
    }

    .sheet-table td.text-left {
        padding-left: 10px !important;
        padding-right: 10px !important;
        text-align: left;
    }

    .bg-even {
        background-color: #e8f7ff;
    }

    .image-container img {
        max-width: 100%;
        width: auto;
        max-height: 500px;
        height: 100%;
        display: block;
        margin: 0 auto;
    }

    .sheet-table .ant-table-thead > tr > th,
    .sheet-table .ant-table-tbody > tr > td {
        padding-top: 0;
        padding-bottom: 0;
        height: 40px;
    }

    input[type="text"] {
        border: 1px solid #d9d9d9;
    }
    
    /* 태블릿 세로모드(768px 이하) 대응 */
    @media screen and (max-width: 768px) {
        .filter-report-table colgroup col:nth-child(1) {
            width: 100px !important;
        }
        
        .filter-report-table colgroup col:nth-child(2) {
            width: 220px !important;
        }
        
        .filter-report-table colgroup col:nth-child(3) {
            width: 70px !important;
        }
        
        .filter-report-table colgroup col:nth-child(4) {
            width: 200px !important;
        }
        
        .filter-report-table colgroup col:nth-child(5) {
            width: 100px !important;
        }
        
        .filter-report-table td[style*="width:150px"] {
            width: 100px !important;
            max-width: 100px !important;
        }
        
        .filter-report-table td[style*="width:250px"] {
            width: 220px !important;
            max-width: 220px !important;
        }
        
        .filter-report-table td[style*="width:90px"] {
            width: 70px !important;
            max-width: 70px !important;
        }
        
        .filter-report-table td[style*="width:430px"] {
            width: 200px !important;
            max-width: 200px !important;
        }
        
        .filter-report-table td[style*="width:120px"] {
            width: 100px !important;
            max-width: 100px !important;
        }
    }
    
    /* 추가된 헤더 스타일 */
    .report-header {
        width: 100%;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        border-radius: 6px;
        overflow: hidden;
        margin-bottom: 10px;
    }
    
    .report-title {
        width: 100%;
        background: linear-gradient(to right, #f0f0f0, #e0e0e0);
        color: #444444;
        font-size: 24px;
        padding: 15px;
        text-align: center;
        border: 1px solid #e0e0e0;
        font-weight: bold;
        text-shadow: 1px 1px 1px rgba(255,255,255,0.8);
    }
    
    .report-info-container {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        border-left: 1px solid #e0e0e0;
        border-right: 1px solid #e0e0e0;
        border-bottom: 1px solid #e0e0e0;
        background-color: #f9f9f9;
    }
    
    .report-info-group {
        display: flex;
        flex: 1;
        min-width: 250px;
    }
    
    .report-info-label {
        background: linear-gradient(to bottom, #e8e8e8, #d8d8d8);
        color: #444444;
        padding: 10px;
        text-align: center;
        width: 90px;
        border-right: 1px solid #e0e0e0;
        border-bottom: 1px solid #e0e0e0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
    }
    
    .report-info-value {
        padding: 10px 15px;
        text-align: center;
        flex: 1;
        border-right: 1px solid #e0e0e0;
        border-bottom: 1px solid #e0e0e0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
    }
</style>

<style>
    .ant-upload-list.ant-upload-list-text {
        display: none !important;
    }
</style>